import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'View Attestations'
  ),
  React.createElement('path', { d: 'M4.8,20.49V4.33A1.19,1.19,0,0,1,6,3.18H14.9V5.74A2.85,2.85,0,0,0,17.82,8.5h2.4v3.68h1.3V7.27a.68.68,0,0,0-.19-.47L16.55,2.07a.64.64,0,0,0-.46-.19H6A2.49,2.49,0,0,0,3.5,4.33V20.49A2.48,2.48,0,0,0,6,22.93h5v-1.3H6A1.18,1.18,0,0,1,4.8,20.49ZM19.88,7.2H17.82A1.55,1.55,0,0,1,16.2,5.74V3.55Z' }),
  React.createElement('path', { d: 'M18.57,13.43a6.5,6.5,0,1,0,6.5,6.5A6.51,6.51,0,0,0,18.57,13.43Zm0,11.7a5.2,5.2,0,1,1,5.2-5.2A5.2,5.2,0,0,1,18.57,25.13Z' }),
  React.createElement('polygon', { points: '27.84 28.54 24.94 25.64 24.28 24.98 23.36 25.9 24.02 26.56 26.92 29.46 27.58 30.12 28.5 29.2 27.84 28.54' })
));